import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Lock } from 'lucide-react';


export const PermissionGate = ({
  children,
  permission,
  permissions,
  requireAll = true,
  role,
  fallback = null,
  showLock = false,
}) => {
  const { hasPermission, hasRole } = useAuth();

  let isAuthorized = true;


  if (role) {
    isAuthorized = hasRole(role);
  }


  if (permission && isAuthorized) {
    isAuthorized = hasPermission(permission);
  }


  if (permissions && permissions.length > 0 && isAuthorized) {
    if (requireAll) {
      isAuthorized = permissions.every(p => hasPermission(p));
    } else {
      isAuthorized = permissions.some(p => hasPermission(p));
    }
  }

  if (isAuthorized) {
    return children;
  }

  if (showLock) {
    return (
      <div className="inline-flex items-center gap-1 text-slate-400 cursor-not-allowed">
        <Lock className="w-4 h-4" />
        <span className="text-sm">Accès restreint</span>
      </div>
    );
  }

  return fallback;
};


export const usePermission = (permission) => {
  const { hasPermission } = useAuth();
  return hasPermission(permission);
};


export const usePermissions = (permissions, requireAll = true) => {
  const { hasPermission } = useAuth();

  if (requireAll) {
    return permissions.every(p => hasPermission(p));
  }
  return permissions.some(p => hasPermission(p));
};


export const PermissionButton = ({
  permission,
  permissions,
  requireAll = true,
  role,
  children,
  className = '',
  disabledClassName = 'opacity-50 cursor-not-allowed',
  showDisabled = true,
  tooltip = 'Vous n\'avez pas la permission d\'effectuer cette action',
  ...props
}) => {
  const { hasPermission, hasRole } = useAuth();

  let isAuthorized = true;

  if (role) {
    isAuthorized = hasRole(role);
  }

  if (permission && isAuthorized) {
    isAuthorized = hasPermission(permission);
  }

  if (permissions && permissions.length > 0 && isAuthorized) {
    if (requireAll) {
      isAuthorized = permissions.every(p => hasPermission(p));
    } else {
      isAuthorized = permissions.some(p => hasPermission(p));
    }
  }

  if (!isAuthorized && !showDisabled) {
    return null;
  }

  return (
    <button
      {...props}
      disabled={!isAuthorized || props.disabled}
      className={`${className} ${!isAuthorized ? disabledClassName : ''}`}
      title={!isAuthorized ? tooltip : props.title}
    >
      {children}
    </button>
  );
};


export const PermissionLink = ({
  permission,
  permissions,
  requireAll = true,
  role,
  children,
  className = '',
  showDisabled = false,
  ...props
}) => {
  const { hasPermission, hasRole } = useAuth();

  let isAuthorized = true;

  if (role) {
    isAuthorized = hasRole(role);
  }

  if (permission && isAuthorized) {
    isAuthorized = hasPermission(permission);
  }

  if (permissions && permissions.length > 0 && isAuthorized) {
    if (requireAll) {
      isAuthorized = permissions.every(p => hasPermission(p));
    } else {
      isAuthorized = permissions.some(p => hasPermission(p));
    }
  }

  if (!isAuthorized) {
    if (showDisabled) {
      return (
        <span className={`${className} opacity-50 cursor-not-allowed`}>
          {children}
        </span>
      );
    }
    return null;
  }

  return (
    <a {...props} className={className}>
      {children}
    </a>
  );
};

export default PermissionGate;